import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { Link as ReactRouterLink, NavLink as ReactRouterNavLink } from 'react-router-dom'

import Icon from 'components/Icon'

import styles from './Link.module.scss'

export default function Link({
  children, className, icon, muted, nav, to, ...others
}: props) {
  const componentClassNames = classNames(
    'Link',
    styles.this,
    muted && 'uk-link-muted',
    className,
  )

  const body = !icon ?
    children : (
      <span>
        <Icon name={icon} />
        {' '}
        {children}
      </span>
    )

  if (to) {
    const Component = nav ? ReactRouterNavLink : ReactRouterLink
    return (
      <Component {...others} to={to} className={componentClassNames}>
        {body}
      </Component>
    )
  }
  return (
    <a {...others} target="_blank" className={componentClassNames}>
      {body}
    </a>
  )
}

Link.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.string,
  muted: PropTypes.bool,
  nav: PropTypes.bool,
  to: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Link/Link.js